import React, { useState, useEffect, useContext } from 'react';
import firebase from 'firebase';
import jwt_decode from "jwt-decode";
import api from '../../api';
import { ModalContext } from '../modal';

const AuthContext = React.createContext({});
const AuthConsumer = AuthContext.Consumer;

const AuthProvider = ({ children }) => {
    const { phoneModal, setPhoneModal } = useContext(ModalContext);
    const [isLogin, setIsLogin] = useState(false);
    const [isProfileImg, setIsProfileImg] = useState(false);
    const [profile, setProfile] = useState({
        firstName: "",
        lastName: "",
        email: "",
        cellNumber: "",
        gender: "",
        city: "",
        area: "",
        country: "",
        profileImage: "",
        socialToken: ""
    });

    const loginSuccess = (token, profToken) => {
        localStorage.setItem('token', token);
        if (profToken) {
            var decoded = jwt_decode(profToken);
            setProfile({ ...profile, firstName: decoded.name, profileImage: decoded.picture })
            localStorage.setItem('Profiletoken', profToken);
            setIsProfileImg(true);
        }
        setIsLogin(true);
    }

    const settingProfile = (data, profUrl) => {
        console.log("data context", data)
        setProfile({ ...profile, firstName: data.firstName, lastName: data.lastName, email: data.email, gender: data.gender, city: data.city, area: data.area, country: data.country })

    }
    const checkProfileUrl = async () => {
        const token = localStorage.getItem('Profiletoken');
        // if (token) {
        //     var decoded = jwt_decode(token);
        //     setProfile({ firstName: decoded.name, profileImage: decoded.picture })
        //     setIsProfileImg(true);
        //     console.log("decoded", decoded);
        // } else {
            try {
                const res = await api.get("/users/user");
                const { firstName, lastName, email, cellNumber, address, city, area, gender, profileImage } = res.data.data.user
                console.log(firstName, lastName, email, cellNumber, address, city, area, gender, profileImage);
                // history.push("/")
                if (profileImage) {
                    setIsProfileImg(true);
                    setProfile({ firstName: firstName, lastName: lastName, email, cellNumber, address, city, area, gender, profileImage: profileImage })
                }
                // console.log()
                // debugger;
                if (!cellNumber || cellNumber === "") {
                    setPhoneModal(true);
                }
                console.log(res.data.data);
            } catch (err) {
                console.log(err)
            }
        // }
    }
    const signOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('Profiletoken');
        firebase.auth().signOut();
        setIsLogin(false);
        setIsProfileImg(false);
    }

    const checkToken = () => {
        const token = localStorage.getItem('token');
        if (token) {
            setIsLogin(true);
        }
    }
    useEffect(() => {
        checkToken();
        checkProfileUrl();
    }, [])

    return (
        <AuthContext.Provider value={{ isLogin, profile, isProfileImg, setIsProfileImg, setProfile, loginSuccess, settingProfile, signOut }}>
            {children}
        </AuthContext.Provider>
    )
}

export { AuthContext, AuthConsumer, AuthProvider };